import { render } from "./AdminsPage.vue?vue&type=template&id=312f0e2a&ts=true"
import script from "./AdminsPage?vue&type=script&lang=ts"
export * from "./AdminsPage?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__